/**
 * NewsStrip — the Home page's front-page strip: the freshest items for the
 * caller's accounts (or, with no lists, statewide), linking into /news.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Newspaper, ChevronRight } from 'lucide-react';
import apiClient from '../../lib/apiClient';
import NewsItemRow from './NewsItemRow';
import './NewsFeed.css';

export default function NewsStrip({ limit = 6 }) {
  const navigate = useNavigate();
  const mine = useQuery({
    queryKey: ['department-news', 'strip', 'mine', limit],
    queryFn: () => apiClient.get('/api/v1/department-news', { query: { scope: 'mine', since: '14d', limit } }),
    staleTime: 120_000,
  });
  const noAccounts = mine.data?.empty_reason === 'no_accounts';
  const fallback = useQuery({
    queryKey: ['department-news', 'strip', 'all', limit],
    queryFn: () => apiClient.get('/api/v1/department-news', { query: { scope: 'all', since: '7d', limit } }),
    enabled: noAccounts,
    staleTime: 120_000,
  });
  const data = noAccounts ? fallback.data : mine.data;
  const items = data?.items || [];
  if (mine.isLoading || (noAccounts && fallback.isLoading)) return null;
  if (!items.length && !mine.error) return null;

  return (
    <section className="ts-card nf-strip">
      <header className="nf-strip-head">
        <h2 className="nf-strip-title"><Newspaper size={16} /> {noAccounts ? 'Agency news' : 'News at your accounts'}</h2>
        <button type="button" className="nf-strip-more" onClick={() => navigate(noAccounts ? '/news?scope=all' : '/news')}>
          All news <ChevronRight size={14} />
        </button>
      </header>
      {mine.error ? (
        <p className="nf-notice nf-notice--err">{mine.error.message}</p>
      ) : (
        <div className="nf-strip-list">
          {items.map((it) => (
            <NewsItemRow
              key={it.id}
              item={it}
              compact
              onDepartment={(d) => navigate(`/news?scope=all&departments=${encodeURIComponent(d.acronym || d.department_id)}`)}
              onContact={(c) => navigate(`/news?scope=all&q=${encodeURIComponent(c.name)}`)}
            />
          ))}
        </div>
      )}
    </section>
  );
}
